import React from 'react';
import RenderInBody from 'components/shared/render_in_body';
import RuleBuilderModalContainer from './RuleBuilderModalContainer';

class RuleBuilderModal extends React.Component {
  render() {
    return (
      <RenderInBody>
        <RuleBuilderModalContainer
          toggleModal={this.props.toggleModal}
          customGroups={this.props.customGroups}
          activeGroup={this.props.activeGroup}
          editing={!!this.props.activeGroup}
          closeModal={this.props.closeModal}
          updateActiveGroup={this.props.updateActiveGroup}
          setGroupInMeta={this.props.setGroupInMeta}
        />
      </RenderInBody>
    );
  }
}

export default RuleBuilderModal;
